import globals from "@/styles/partials/global-variables";
import { QuestionHeader, NormalText } from "../partials/texts";

export default {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    "& .question-info-text": {
      whiteSpace: "pre-wrap",
      maxWidth: "770px",
      color: globals.colors.gray4,
      textAlign: "center",
      marginBottom: "10px",
      lineHeight: "1.5"
    },
    "& .question-header": {
      ...QuestionHeader
    },
    "& .question-type-hint": {
      ...NormalText
    }
  }
};
